<template>
   <div>
     <div class="search_unit">
        <div style='display:inline-block;'>
          <el-input placeholder="订单号/收货人姓名/收货电话" v-model="keywords" class="input-with-select" @change='getList()'>
                    <el-select v-model="type" slot="prepend" placeholder="筛选条件">
                      <el-option label="未发货" value="0"></el-option>
                      <el-option label="已发货" value="1"></el-option>
                      <el-option label="发货中" value="8"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click='getList()'></el-button>
          </el-input>
        </div>
       <!-- <el-dropdown split-button type="primary" @click="doImport" class='fr hiddensmonly' size="small" >
          导入快递单
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>功能未开放</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>-->
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="props">
          <div class="expand-row">收货人:{{ props.row.name }}</div>
          <div class="expand-row">收货电话:{{ props.row.mobile }}</div>
          <div class="expand-row">收货地址:{{  props.row.province+props.row.city+props.row.county+props.row.address}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="下单时间">
      <template slot-scope="scope"> 
           {{scope.row.createtime | timeToDate}}
      </template>
      </el-table-column>
      <el-table-column
        prop="ordernum"
        label="订单号"
        >
      </el-table-column>
      <el-table-column
        prop="name"
        label="收货人">
      </el-table-column>
      <el-table-column
        label="订货商品">
        <template slot-scope="scope"> 
             <div v-for='item in scope.row.ordergoods' :key='item.id'>
               <el-badge :value="item.name" class="item" type="warning"></el-badge>X<span class="fnums">{{item.nums}}</span>
             </div>
             <div v-if="scope.row.hasgift==1">
                <div v-for="item in scope.row.giftlist" :key="item.id">
                  【赠送】{{item.name}}x{{item.nums}}
                </div>
             </div>    
        </template>
      </el-table-column>
      <el-table-column
        label="物流信息">
        <template slot-scope="scope"> 
          <div v-if="scope.row.expressnumber!=null">
           <div>{{scope.row.expressname}}</div>
           <div>{{scope.row.expressnumber}}</div>
          </div> 
          <div v-else>
            <div>{{scope.row.memo}}</div>
           </div>     
        </template>
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope"> 
          <div><el-tag :type="scope.row.status | toFahuoStyle">{{scope.row.status | toFahuoWord}}</el-tag> </div>
          <div v-if="scope.row.freight>0 && scope.row.ispay==0" class="yfwarning">(运费未支付)</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope"> 
            <!-- <el-dropdown split-button type="primary" @click='doUpload(scope.row.id)' @command='(command)=>handleItem(command,scope.row.id)'>
              上传
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command='vfahuo'>自提/虚拟发货</el-dropdown-item>
                <el-dropdown-item command='canceljst'>从聚水潭撤回</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>-->
        </template>
      </el-table-column>
    </el-table>
      <div class='page-number'>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          >
        </el-pagination>
      </div>
   </div> 
</template>

<script>
export default {
  data(){
     return {
        tableData:[],
        startDate:'',
        endDate:'',
        type:'',
        keywords:'',
        pageinfo:{
          total:0,
          pagesize:10,
          pageindex:1
        }
     }
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/fahuo/getFahuoList",{pageinfo:this.pageinfo,startdate:this.startDate,enddate:this.endDate,keywords:this.keywords,type:this.type}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info.orderlist
                  this.pageinfo=data.result.info.pageinfo 
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      doUpload(realorderid){
          this.$post("/jst/upload_single",{realorderid:realorderid}).then((data)=>{
               if(data.result.success){
                  this.$message.success(data.result.info)
                  this.getList()
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      doImport(){
        this.$post("/jst/importExpressNo",{}).then((data)=>{
               if(data.result.success){
                  this.$message.success(data.result.info)
                  this.getList()
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      handleItem(command,orderid){
        switch(command){
          case 'vfahuo':
                  this.$prompt('请输入发货备注', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消'
                }).then(({ value }) => {
                  if(value==''||value==undefined){
                    this.$message.error("备注不能为空");return false;
                  }
                  this.$post("/jst/vFahuo",{realorderid:orderid,memo:value}).then((data)=>{
                    if(data.result.success){
                        this.$message.success(data.result.info)
                        this.getList()
                    }else{
                        this.$message.error(data.result.info)
                    }
                  })
                }).catch(() => {     
                });
                break;
          case 'canceljst':
                this.$post("/jst/cancelJstFahuo",{realorderid:orderid}).then((data)=>{
                    if(data.result.success){
                        this.$message.success(data.result.info)
                        this.getList()
                    }else{
                        this.$message.error(data.result.info)
                    }
                })
                break;      
          default:
                this.$message.error("选项有误");      
        }
      }
  }
}
</script>

<style scoped lang="scss">
.order-detail {font-size:14px;}
.order-detail li{padding: 0.1rem;list-style-type:none;border-bottom: 1px dashed #ccc;}
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
.fnums{font-weight: 800;}
.yfwarning{color:#c54040;}
.expand-row{padding:8px;padding-left: 48px!important;}
</style>
